var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tone-banner-content"},[_c('div',{staticClass:"tone-banner-image",style:({ backgroundImage: `url(${_vm.tonePageStoreBannerImageSrc})` })}),_c('div',{staticClass:"tone-overlay-image"},[_c('h1',{staticClass:"tone-banner-title"},[_vm._v(" "+_vm._s(_vm.tonePageStoreBannerImageTitle)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }